import React, { CSSProperties } from 'react';
import mustache from 'mustache';
import Checkbox from '../../../../../ui/Checkbox/Checkbox';
import MustacheNestedRender from '../../../../../ui/MustacheNestedRender';
import TextLink from '../../../../../ui/TextLink/TextLink';
import { useTranslations } from '../../../../../../hooks/useTranslations';
import { useTheme } from '../../../../../../hooks/useTheme';

const templateLinkContext = (href: string, style?: CSSProperties) => {
  const ALink: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
    <TextLink
      key={href}
      linkStyle={{ sDefault: { color: style?.color, fontSize: 'inherit' } }}
      href={href || ''}
    >
      {children}
    </TextLink>
  );
  return ALink;
};

interface NotificationPreferencesOptinProps {
  isChecked: boolean;
  isLandscape: boolean;
  onChange: (checked: boolean) => void;
}

const NotificationPreferencesOptin = ({
  isLandscape,
  isChecked,
  onChange,
}: NotificationPreferencesOptinProps) => {
  const { linksNoneDefault } = useTheme();

  const { notificationCenterSublimeOptin } = useTranslations();

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.currentTarget.checked);
  };

  return (
    <div
      data-testid={`column-three-${isLandscape ? '7' : '12'}`}
      style={{
        gridColumn: `span ${isLandscape ? '7' : '12'}`,
        marginTop: isLandscape ? '0.8rem' : undefined,
        marginBottom: isLandscape ? undefined : '0.8rem',
      }}
    >
      <Checkbox
        id="notificationPreferencesOptIn"
        onChange={handleCheckboxChange}
        checked={isChecked}
        labelTextCellStyle={{ textAlign: 'left' }}
      >
        <span>
          <MustacheNestedRender
            template={mustache.parse(notificationCenterSublimeOptin ?? '')}
            context={
              new mustache.Context({
                termsLink: () =>
                  templateLinkContext(
                    'https://corp.narvar.com/profile-terms-of-service',
                    linksNoneDefault,
                  ),
                privacyLink: () =>
                  templateLinkContext(
                    'https://corp.narvar.com/privacy-policy#consumer-annex',
                    linksNoneDefault,
                  ),
              })
            }
          />
        </span>
      </Checkbox>
    </div>
  );
};

export default NotificationPreferencesOptin;
